import { Offer, RoomRule } from "@quote/quote/api/init_quote/types";

export enum RoomType {
  Standard = "standard",
  LargeRoom = "largeroom",
}

export type Room = {
  key: string;
  pax: number;
  type: RoomType;
  name: string;
  isValid: boolean;
};

export type PrevState = {
  rooms: Room[];
};

interface State {
  rooms: Room[];
  roomRules: RoomRule[];
  prevState: PrevState | null;
  maxBookingPax: number;
  maxRoomPax: number;
}

interface Actions {
  addPaxAt: (index: number) => void;
  addRoom: (isFourBall: boolean) => void;
  removePaxAt: (index: number) => void;
  removeRoom: (index: number, room: Room[]) => void;
  setPrevState: () => void;
  resetToPrev: () => void;
  resetState: () => void;
  setRoomsFromPax: (groupSize: number, roomRules?: RoomRule[]) => void;
  setStateFormOffer: (offer: Offer, groupSize?: number) => void;
}

interface Utils {
  guestsCount: () => number[];
  isMaxPaxAt: (room: Room) => boolean;
  isMaxRooms: () => boolean;
  isMinPaxAt: (room: Room) => boolean;
  isMinRooms: () => boolean;
  totalPax: () => number;
  isQuartetGroup: () => boolean;
  generateSummaryText: () => string;
  totalRooms: () => number;
}

export type RoomsState = State & {
  roomsActions: Actions;
  roomsUtils: Utils;
};
